import * as Sentry from '@sentry/browser';
import axios from 'axios';
import createSurfaceNodeFileUploadUrl from 'graphql/surface-node/mutations/create-surface-node-file-upload-url';
import { asyncAction } from 'utils/js';
import { acceptTypeMap } from 'components/file-input';
import { invert, get } from 'lodash';

// @todo uploadFile function should throw
export function useUploadSurfaceNodeFile(
  surfaceId: string,
): (file: any, name?: string, onProgress?: any ) => Promise<string | undefined> {
  return async function uploadFile(file: any, name?, onProgress?) {
    const ContentType = file.type;
    const extension = get(invert(acceptTypeMap), file.type);
    const nameOfFile = name ?? file.name;

    let fileName = `${surfaceId}/${nameOfFile
      .replace(/\s/g, '-')
      .toLowerCase()}`;

      if(extension != undefined){
        fileName+=`.${extension}`
      }

    const response = await createSurfaceNodeFileUploadUrl({
      input: {
        file: {
          name: fileName,
          type: ContentType,
        },
      },
    });

    if (response.isFailure) {
      console.error(response.getError());
      return;
    }

    const { url, bucketName, region } = response.getField('data');

    const config = {
      /*params: {
          Key: values.name,
          ContentType
        },*/
      headers: {
        Accept: '*/*',
        'Content-Type': ContentType,
      },
      onUploadProgress: onProgress
    };

    const [error] = await asyncAction(axios.put(url, file, config));

    if (error) {
      console.error('----------- UPLOAD ERROR -----------------');
      console.error(error);
      Sentry.captureException(error);
    }

    return `https://s3.${region}.amazonaws.com/${bucketName}/${fileName}`;
  };
}
